import { render, staticRenderFns } from "./MainContentHeader.vue?vue&type=template&id=4793bd3b&scoped=true"
import script from "./MainContentHeader.vue?vue&type=script&lang=js"
export * from "./MainContentHeader.vue?vue&type=script&lang=js"
import style0 from "./MainContentHeader.vue?vue&type=style&index=0&id=4793bd3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4793bd3b",
  null
  
)

export default component.exports